// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3swn3","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Uuio"};